import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const SentIcon = createSvgIcon(<path d="M10 12L1 8L21 1L14 21L10 12ZM21 1L10 12" {...strokeProps} />, {
  displayName: 'SentIcon',
  viewBox: '0 0 22 22'
});
